<template lang="pug">
  div.e-table-inner
    div(:class="tableWrapperClass")
      div(
      :class="{'showed-columns-empty': !showedColumns}"
      ).fixed-header
        div.table-inner-head
          table(ref="tableHeader")
            colgroup(v-if="showedColumns")
              col(
              v-for="(item, fieldName) in showedColumns"
              :width="item.width || defaultColWidth"
              )
              col(
              v-if="showActionButtons"
              :width="actionColumnWidth"
              )
            thead
              tr
                th(v-if="showedColumns" v-for="(item, fieldName) in showedColumns")
                  div.flex-table
                    div.sortable.text() {{ item.label }}
                    template(v-if="meta")
                      div.sortable.arrows(v-if="meta.sort && meta.fields && meta.fields[fieldName] && meta.fields[fieldName].sortable")
                        span.up(:class="meta.sort[fieldName] == 'asc' ? 'active' : ''" v-on:click.prevent="letSort(fieldName, 'asc')")
                        span.down(:class="meta.sort[fieldName] == 'desc' ? 'active' : ''" v-on:click.prevent="letSort(fieldName, 'desc')")
                th(
                v-if="showActionButtons"
                )
          div.progress-wrapper
            e-progress(:loading="loading")
        e-perfect-scrollbar(
        ref="scrollbar"
        :emitTypes="['vue']"
        @ps-scroll-x="scrollHandler($event.event)"
        :config="{suppressScrollY: false, suppressScrollX: false}"
        )
          div.table-inner-body(:style="styles")
            table
              colgroup(v-if="showedColumns")
                col(
                v-for="(item, fieldName) in showedColumns"
                :width="item.width || defaultColWidth"
                )
                col(
                v-if="showActionButtons"
                :width="actionColumnWidth"
                )

              tbody(
              v-if="error"
              )
                tr(key="error")
                  td(:colspan="colspan").table-error {{error}}

              tbody(
              v-else-if="loading && data.length===0"
              )
                tr(key="prefetch")
                  td(:colspan="colspan")

              tbody(
              v-else-if="data.length===0"
              )
                tr(key="empty")
                  td(:colspan="colspan") Нет записей

              tbody(
              v-else
              )
                template(v-for="(value, i) in data")
                  tr(
                  :key="value[idKeyName]"
                  )
                    td(
                    v-for="field, fieldName, itemIndex in showedColumns"
                    :key='itemIndex'
                    )
                      template(v-if="$scopedSlots[fieldName]")
                        slot(
                        :name="fieldName"
                        :row="value"
                        :toggleRow="toggleRow"
                        :isExpanded="openedRows.indexOf(value[idKeyName]) > -1"
                        )
                      div(v-else-if="typeof value[fieldName] === 'boolean'") {{value[fieldName] ? 'Да' : 'Нет'}}
                      div(v-else-if="typeof(value[fieldName]) !== 'object'" v-html="value[fieldName]")
                      div(v-else-if="Array.isArray(value[fieldName])" v-e-array-as-line="value[fieldName]")
                      div(v-else-if="value[fieldName] && fields[fieldName].path") {{ value[fieldName][fields[fieldName].path] }}
                      div(v-else-if="value[fieldName] && value[fieldName].name") {{ value[fieldName].name }}
                    td(v-if="showActionButtons")
                      div.buttons
                        button.row-delete(
                        v-if="showDeleteButton"
                        @click="deleteItem(value)"
                        )
                  tr(
                  v-if="openedRows.indexOf(value[idKeyName]) > -1"
                  :key="`expanded_${value[idKeyName]}`"
                  ).expanded
                    td(:colspan="colspan")
                      slot(
                      name="expandedRow"
                      :row="value"
                      :reFetchOpenedRowData="reFetchOpenedRowData"
                      :loading="openedRowsLoading.indexOf(value[idKeyName]) > -1"
                      )


    div(v-if="enableInnerPagination").footer-nav
      e-pagination(
      v-if="meta"
      :auto="false"
      :pageCount="meta.pageCount"
      :currentPage="meta.currentPage"
      :totalCount="meta.totalCount"
      :perPage="meta.perPage"
      @paginate="changePaginate"
      )
</template>

<script>
  import userFriendlyEr from '../../utils/userFriendlyEr.js'
  import url from '../../utils/url'

  export default {
    name: 'e-table-inner',
    data () {
      this.fetchOpenedSettings = {}
      return {
        items: null,
        loading: false,
        currentSort: '',
        paginateObj: null,
        error: null,

        openedRows: [],
        openedRowsLoading: []
      }
    },
    props: {
      styles:{
        type: Object,
        default: function () {
          return null
        }
      },
      tableWrapperClass: {
        type: String,
        default: 'table tscroll'
      },
      // be default showed all
      visibleColumns: {
        type: Object,
        default: function () {
          return null
        }
      },
      showDeleteButton: {
        type: Boolean,
        default: true
      },
      autoFetch: {
        type: Boolean,
        default: true
      },
      itemsEndpoint: {
        // eslint-disable-next-line
        default: function (ctx) {
          return {
            url: null
          }
        }
      },
      enableInnerPagination: {
        type: Boolean,
        default: true
      },
      afterFetchData: {
        type: Function,
        // eslint-disable-next-line
        default: function (ctx, data, responses) {
          /* data.data = [
            ...data.data,
            ...data.data,
            ...data.data,
            ...data.data,
            ...data.data
          ] */
          return data
        }
      },
      showRemoveConfirmation: {
        type: Boolean,
        default: true
      },
      defaultColWidth: {
        type: [Number, String],
        default: '50%'
      },
      actionColumnWidth: {
        type: Number,
        default: 100
      },
      idKeyName: {
        type: String,
        default: 'id'
      },
      fetchOpenedRowData: {
        type: Function,
        // eslint-disable-next-line
        default: (row, sort, paginate) => Promise.resolve(true)
      },
      parallelFetchData: {
        type: Function,
        // eslint-disable-next-line
        default: (ctx) => Promise.resolve()
      },
      // enabled if not null
      eventsStreamName: {
        type: String,
        default: null
      },
      tableId: {
        type: String,
        default: function () {
          return ''
        }
      },
      saveOpenedRowsInRoute: {
        type: Boolean,
        default: true
      },
      canOpenRow: {
        type: Function,
        // eslint-disable-next-line
        default: (row) => true
      }
    },
    methods: {
      scrollHandler ($event) {
        let {scrollLeft = 0} = $event.target
        this.$refs.tableHeader.style.marginLeft = `-${scrollLeft}px`
      },
      changePaginate ($event) {
        this.paginateObj = $event
        this.fetchData(true)
      },
      // listener for outer search, and update
      // use by $refs
      // ex: this.$refs.municipalityTable.updateTable()
      updateTable () {
        this.fetchData()
      },
      deleteItem (item) {
        if (this.showRemoveConfirmation) {
          this.$e.confirmBox(
            'Запись будет удалена из таблицы',
            'Удалить?',
            'Да'
          ).then(() => {
            this.$emit('deleteItem', item)
          })
        } else {
          this.$emit('deleteItem', item)
        }
      },
      update (url, responses) {
        let data = this.$sharedServices.store.getters.readUrlEndpoint(url)
        if (data) {
          this.items = this.afterFetchData(this, data, responses)
          if (this.$parent.paginationMeta) {
            this.$parent.paginationMeta = this.items._meta
          }
        } else {
          this.items = null
          if (this.$parent.paginationMeta) {
            this.$parent.paginationMeta = null
          }
        }
      },
      updateScroll (delay = 50, scrollToTop = false) {
        setTimeout(() => {
          if (this.$refs.scrollbar) {
            if (scrollToTop) {
              // setScrollTop called update
              this.$refs.scrollbar.setScrollTop(0)
            } else {
              this.$refs.scrollbar.update()
            }
          }
        }, delay)
      },
      fetchData (scrollToTopAfterFetch = false) {
        this.error = null
        const endpoint = typeof this.itemsEndpoint === 'function' ? this.itemsEndpoint(this).url : this.itemsEndpoint
        if (endpoint === null) {
          return Promise.resolve()
        }

        this.loading = true
        return Promise.all([
          this.$sharedServices.store.dispatch('updateUrlEndpoint', {
            endpoint,
            params: {
              disableGlobalError: true
            }
          }),
          this.parallelFetchData(this)
        ]).then((responses) => {
          this.$emit('loaded')
          this.loading = false
          this.update(endpoint, responses)
          this.updateScroll(50, scrollToTopAfterFetch)
          return responses[0]
        }).catch(e => {
          console.error(e)
          this.error = userFriendlyEr.recognize(e, endpoint)
          this.loading = false
          this.updateScroll(50, scrollToTopAfterFetch)
          return Promise.reject(e)
        })
      },
      /* Меняем сортировку */
      letSort (item, direct) {
        if (this.meta.sort) {
          let key = Object.keys(this.meta.sort)[0]
          if (key !== item) {
            key = item
          }
          if (direct === 'desc') key = `-${key}`
          this.currentSort = key
          this.$emit('letSort', key)
          if (this.autoFetch) {
            this.fetchData(true)
          }
        }
      },
      toggleRow (row) {
        if (this.openedRows.indexOf(row[this.idKeyName]) > -1) {
          this.closeRow(row)
        } else {
          this.openRow(row)
        }
      },
      openRow: async function (row) {
        if (!this.canOpenRow(row)) {
          return
        }
        this.openedRows.push(row[this.idKeyName])
        try {
          this.openedRowsLoading.push(row[this.idKeyName])
          const prev = this.fetchOpenedSettings[row[this.idKeyName]] || {}
          await this.fetchOpenedRowData(row, prev.sort, prev.paginate)
        } catch (er) {
          this.$e.errorBox(er)
        } finally {
          this.openedRowsLoading = this.openedRowsLoading.filter(id => id != row[this.idKeyName])
          this.updateScroll()
        }
        this.updateRowsInRoute()
      },
      closeRow (row) {
        this.openedRows = this.openedRows.filter(id => id != row[this.idKeyName])
        this.updateScroll()
        this.updateRowsInRoute()
      },
      reFetchOpenedRowData: async function (row, {sort, paginate}) {
        try {
          this.openedRowsLoading.push(row[this.idKeyName])
          this.fetchOpenedSettings[row[this.idKeyName]] = {
            sort,
            paginate
          }
          await this.fetchOpenedRowData(row, sort, paginate)
        } catch (er) {
          this.$e.errorBox(er)
        } finally {
          this.openedRowsLoading = this.openedRowsLoading.filter(id => id != row[this.idKeyName])
          this.updateScroll()
        }
      },
      getOpenedRowsQueryParamName () {
        return `openedRows${this.tableId}`
      },
      openRowsWhichExistInRouteQuery () {
        const route = url.getRoute(this.$route)
        const openedRows = route.query[this.getOpenedRowsQueryParamName()] || []
        const items = this.data
        items.forEach(row => {
          if (openedRows.indexOf(row[this.idKeyName]) > -1) {
            this.openRow(row)
          }
        })
      },
      updateRowsInRoute () {
        if (this.saveOpenedRowsInRoute !== true) {
          return
        }
        const route = url.getRoute(this.$route)
        route.query[this.getOpenedRowsQueryParamName()] = this.openedRows.slice()
        this.$router.replace(route)
      }
    },
    created () {
      this.subs = this.$emitter.listen(this.eventsStreamName, ({action}) => {
        if (action === 'updateTable') {
          this.updateTable()
        }
      })
      this.fetchData(true).then(() => {
        this.openRowsWhichExistInRouteQuery()
      })
    },
    destroyed () {
      if (this.subs) {
        this.subs.unsubscribe()
      }
    },
    computed: {
      colspan () {
        return 100
      },
      data () {
        if (this.items && this.items.data) {
          return this.items.data
        }
        return []
      },
      meta () {
        if (this.items && this.items._meta) {
          return this.items._meta
        }
        return {}
      },
      fields () {
        if (this.items && this.items._meta && this.items._meta.fields) {
          return this.items._meta.fields
        }
        return null
      },
      showedColumns () {
        if (this.visibleColumns === null && this.fields !== null) {
          return this.fields
        }
        return this.visibleColumns
      },
      showActionButtons () {
        if (this.showDeleteButton) {
          return true
        }
        return false
      }
    }
  }
</script>
